import { createApiSlice } from "@common";
import {
  CRUD_ACCOUNT_SOURCE,
  CRUD_ACCOUNT_SOURCE_BY_ID,
  GET_ACCOUNT_SOURCE_BY_ACCOUNT_ID,
} from "@routes";

// 1 to 1
const apiConfig = [
  {
    name: "addAccountSource",
    method: "post",
    url: CRUD_ACCOUNT_SOURCE,
    stateKey: "message",
  },
  {
    name: "getAccountSource",
    method: "get",
    url: CRUD_ACCOUNT_SOURCE,
    stateKey: "data",
  },
  {
    name: "getAccountSourceByAccountId",
    method: "get",
    url: GET_ACCOUNT_SOURCE_BY_ACCOUNT_ID,
    stateKey: "details",
  },
  {
    name: "getAccountSourceById",
    method: "get",
    url: CRUD_ACCOUNT_SOURCE_BY_ID,
    stateKey: "details",
  },
  {
    name: "deleteAccountSource",
    method: "delete",
    url: CRUD_ACCOUNT_SOURCE,
    stateKey: "message",
  },
];

const customReducers = {
  initialState: {
    data: [],
    details: [],
    additionalData: [],
  },
  reducers: {
    setAdditionalData: (state, action) => {
      state.additionalData = action.payload;
    },
  },
  extraReducers: {},
};

const { slice, thunks, actions } = createApiSlice(
  "accountSource",
  apiConfig,
  customReducers
);

const accountSourceSlice = slice;

export default accountSourceSlice.reducer;

export const {
  addAccountSource,
  getAccountSource,
  getAccountSourceByAccountId,
  getAccountSourceById,
  deleteAccountSource,
} = thunks;

export const { rowSelect, setAdditionalData } = actions;
